import { render, staticRenderFns } from "./ColorsChangeColor.vue?vue&type=template&id=6d4d3804&scoped=true&"
import script from "./ColorsChangeColor.vue?vue&type=script&lang=js&"
export * from "./ColorsChangeColor.vue?vue&type=script&lang=js&"
import style0 from "./ColorsChangeColor.vue?vue&type=style&index=0&id=6d4d3804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4d3804",
  null
  
)

export default component.exports